// extracted by mini-css-extract-plugin
export var cardHeader = "_u3-0";
export var reorderHandle = "_u3-3";
export var titleArea = "_u3-1";
export var titleAreaWithHandle = "_u3-2";